import { Layout } from "antd";
import MenuLateral from "shared/components/menu-lateral";
import "./Layout.scss";

const { Content } = Layout;
const LayoutSemMargem: React.FC = (props) => {
  const { children } = props;

  return (
    <Layout>
      <Layout>
        <MenuLateral />
        <Content>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default LayoutSemMargem;
